import React from 'react';
import './TransportBanner.css';

const BannerContent = () => (
  <div className="transport-ticker-content" aria-hidden="true">
    <span className="transport-ticker-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 17h4V5H2v12h3" /><circle cx="7.5" cy="17.5" r="2.5" /><path d="M14 17h1a2 2 0 0 0 2-2v-2h2l3-3-1.5-1.5L19 7h-5v10" /><circle cx="18.5" cy="17.5" r="2.5" />
      </svg>
    </span>
    <span className="transport-ticker-headline">FREE RIDE TO & FROM EVERY APPOINTMENT</span>
    <span className="transport-ticker-divider">|</span>
    <span className="transport-ticker-sub">+ Monthly Transportation Support</span>
    <a
      href="tel:+18777725150"
      className="transport-ticker-cta"
      data-testid="transport-call-btn"
      onClick={(e) => e.stopPropagation()}
    >
      Call Now
    </a>
    <span className="transport-ticker-spacer" />
  </div>
);

const TransportBanner = () => {
  return (
    <div className="transport-banner" data-testid="transportation-banner" role="marquee" aria-label="Free transportation to and from every appointment. Monthly transportation support. Call now.">
      <div className="transport-ticker-track">
        <BannerContent />
        <BannerContent />
        <BannerContent />
      </div>
    </div>
  );
};

export default TransportBanner;
